import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { Modal as AntModal, Spin } from "antd";
import Modal from "react-modal";
import MapComponent from "./MapComponent";

const FarmerPlotMappingList = (props) => {
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));

  const [deleteLoading, setDeleteLoading] = useState(false);

  const [urlAttachment, setUrlAttachment] = useState([]);

  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, farmerId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this farmer detail?",
      onOk() {
        const data = {
          farmerId: farmerId,
        };

        setDeleteLoading(data);
        deleteOperation(
          {
            url: `/api/farmerPlotMapping/`,
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success(data);
            setDeleteLoading(false);
            FillDetail();
          },
          (error) => {
            toast.error(error);
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const { sendRequest: getFarmerData } = useHttp();

  const FillDetail = () => {
    getFarmerData(
      {
        url: `/api/farmerEnrolment/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          const sortedData = res.sort((a, b) => b.farmerId - a.farmerId);
          setData(sortedData);
          setAllData(sortedData);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getFarmerData]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  const plotCoordinates =
    '[{"latitude":18.571024347087693,"longitude":73.6963463947177},{"latitude":18.571157195027883,"longitude":73.69917210191488},{"latitude":18.568872386732416,"longitude":73.69874596595764},{"latitude":18.568488139292725,"longitude":73.69579553604126}]';

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const handleSearch = (e) => {
    var filetrtext =e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.farmerNo?.toLowerCase().includes(filetrtext) ||
        item.farmerName?.toLowerCase().includes(filetrtext) ||
        item.fieldExecutiveName?.toLowerCase().includes(filetrtext) ||
        item.farmerStatus?.toLowerCase().includes(filetrtext) ||
        item.category?.toLowerCase().includes(filetrtext)
    );

   setData(filterdata);    
    setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "60%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "1000px", // Adjust the width as needed
      height: "550px",
      minHeight: "550px",
      overflow: "auto",
      //  border: "5px solid #96dc00",
    },
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (id) => {
    if (id) {
      getFarmerData(
        {
          url: `/api/farmerPlotMapping/?orgId=${localStorage.getItem(
            "orgId"
          )}&empId=${localStorage.getItem("empId")}&farmerId=${id}`,
        },
        (res) => {
          if (res) {
            setSelectedData(res);
          }
        }
      );
    }

    setIsModalOpen(true);
  };

  const [selectedApprovalData, setSelectedApprovalData] = useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (input) => {
    console.log(input);
    setSelectedApprovalData(input);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        itemId: selectedApprovalData && selectedApprovalData.farmerId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: localStorage.getItem("orgId"),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    updateApprovalStatus(
      {
        url: "/api/farmerPlotMappingApproval/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);

        setApprovalPopupVisible(false);
        setRemark("");
        FillDetail();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div>
          <h4 className="card-title">
            <b>Farmer Plot Mapping Detail</b>
          </h4>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => setIsModalOpen(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr style={{ border: "1px solid black" }} />
          </div>
          {selectedData && (
            <div className="content" >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-3">
                    <div className="card card-primary card-outline">
                      <div className="card-body box-profile">
                        <h3
                          className="profile-username text-center"
                          style={{ margin: "5px 0" }}
                        >
                          {selectedData?.farmerName}
                        </h3>

                        <ul className="list-group list-group-unbordered mb-3">
                          <li className="list-group-item">
                            Farmer No:
                            <span className="float-right">
                              {selectedData?.farmerNo}
                            </span>
                          </li>
                          <li className="list-group-item">
                            Field Executive:
                            <span className="float-right">
                              {selectedData?.fieldExecutiveName}
                            </span>
                          </li>
                          <li className="list-group-item">
                            Total Land:
                            <span className="float-right">
                              {selectedData?.totalLand}
                            </span>
                          </li>
                          <li className="list-group-item">
                            Registration Date:
                            <span className="float-right">
                              {selectedData?.registrationDate}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-9">
                    <div className="card">
                      <div className="card-header p-2">
                        <ul className="nav nav-pills">
                          {selectedData.plotData.map((plot, index) => (
                            <li key={plot.plotId} className="nav-item">
                              <a
                                className={`nav-link ${
                                  index === 0 ? "active" : ""
                                }`}
                                href={`#plot${index}`}
                                data-toggle="tab"
                              >
                                {plot.plotName}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="card-body">
                        <div className="tab-content">
                          {selectedData.plotData.map((plot, index) => (
                            <div
                              key={plot.plotId}
                              className={`tab-pane ${
                                index === 0 ? "active" : ""
                              }`}
                              id={`plot${index}`}
                            >
                              <h4>{plot.plotName} Details</h4>
                              <div className="row border p-3 rounded">
                                {/* First Column */}
                                <div className="col-md-6">
                                  <p>
                                    <strong>Plot Mapping Date:</strong>{" "}
                                    {plot.mappingDate}
                                  </p>
                                  <p>
                                    <strong>Farm Location:</strong>{" "}
                                    {plot.farmLocation}
                                  </p>
                                  <p>
                                    <strong>Plot Area:</strong> {plot.plotArea}{" "}
                                    {plot.plotAreaUnit}
                                  </p>
                                </div>

                                {/* Second Column */}
                                <div className="col-md-6">
                                  <p>
                                    <strong>Irrigation Source:</strong>{" "}
                                    {plot.irrigationSource}
                                  </p>
                                  <p>
                                    <strong>Land Ownership:</strong>{" "}
                                    {plot.landOwnership}
                                  </p>
                                  <p>
                                    <strong>Soil Type:</strong> {plot.soilType}
                                  </p>
                                  <p>
                                    <strong>Landmark:</strong> {plot.landMark}
                                  </p>
                                </div>
                              </div>
                              <br />
                              <h5>
                                <strong>Crops</strong>
                              </h5>

                              <div className="table-responsive">
                                <table className="table table-sm table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Sr. No</th>
                                      <th>Crop Type</th>
                                      <th>Crop Name</th>
                                      <th>Variety Name</th>
                                      <th>Input Template</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {plot?.cropList?.map((itm, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{itm.cropType}</td>
                                        <td>{itm.cropName}</td>
                                        <td>{itm.cropVariety}</td>
                                        <td>{itm.templateName}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                              <MapComponent
                                coordinates={plot?.plotCoordinates}
                              />
                              <br />
                              <h5>
                                <strong>Plot Photos</strong>
                              </h5>
                              <div className="row border p-3 rounded">
                                <div className="row">
                                  {JSON.parse(plot?.plotPhotosUrls)?.map(
                                    (url, index) => (
                                      <div className="col-md-4" key={index}>
                                        <img
                                          src={`${process.env.REACT_APP_FILE_URL}${url}`}
                                          alt={`Plot photo ${index + 1}`}
                                          width={200}
                                        />
                                        &nbsp;
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal>

      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-9">
            <label className="card-title  my-3">
              {" "}
              &nbsp; &nbsp;Farmer Plot Mapping Details
            </label>{" "}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center table-responsive">
                        <thead>
                          <tr>
                            <th>Farmer Name</th>
                            <th>Farmer No</th>
                            <th>Plot Size(ha)</th>
                            <th>Farmer Category</th>
                            <th>Field Executive</th>
                            <th>LGA</th>
                            <th>State</th>
                            <th>Farmer Status</th>

                            <th>Edit</th>
                            <th>Approval</th>
                            <th>View</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.farmerName}</td>
                                <td>{x.farmerNo}</td>
                                <td>{x.plotSizeInHa}</td>
                                <td>{x.category}</td>
                                <td>{x.fieldExecutiveName}</td>
                                <td>{x.lga}</td>
                                <td>{x.state}</td>
                                <td>{x.farmerStatus}</td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                    disabled={
                                      x.approved === 1 || x.approved === 2
                                    }
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    disabled={
                                      x.approved === 1 || x.approved === 2
                                    }
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x.farmerId)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  {deleteLoading === x ? (
                                    <Spin />
                                  ) : (
                                    <button
                                      onClick={(e) =>
                                        handleDelete(e, x.farmerId)
                                      }
                                      className="btn"
                                      disabled={
                                        x.approved === 1 || x.approved === 2
                                      }
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Farmer Plot Mapping Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>
    </>
  );
};

export default FarmerPlotMappingList;
